import _ from 'underscore';
import ko from 'knockout';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import koValidation from '@bingads-webui-component-legacy/ko-validation/index';
import controlSpecified from '@bingads-webui-component-legacy/form/viewmodel/control/index';
import generate from '@bingads-webui-component-legacy/form/viewmodel/control/readonly-computed';
import {isEditing} from '@bingads-webui-component-legacy/form/service/status';

export default class SimpleFormViewModel {
  constructor({
    fields,
    schema,
    model,
    customValidators,
  }) {
    const properties = _.pluck(fields, 'property');

    koSchema.properties(this, schema, properties, model, customValidators);

    _.each(fields, (field) => {
      if (field.value) {
        this[field.property] = generate(field.value, this).extend({
          validate: [koValidation.passive()],
        });
      }

      if (_.isUndefined(this[field.property])) {
        this[field.property] = ko.observable();
      }

      const observable = this[field.property];

      controlSpecified(field.control, observable, schema.properties[field.property], field, this);

      if (_.has(observable, 'validators')) {
        _.each(field.validators, (config, name) => {
          const validator = observable.validators[name];

          if (validator) {
            _.extend(validator, config);
          }
        });
      }
    });

    const validator = koValidation.passive();

    this.$overall = ko.observable().extend({
      validate: [validator],
    });

    this.$overall.validators = { passive: validator };

    this.editing = isEditing(schema, model);
  }
}
